import {Component, OnInit, Renderer2} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {FooterComponent} from '../../footer/footer.component';
import {Router, RouterModule} from '@angular/router';
import {LayoutService} from '../../../shared/services/layout.service';
import {SharedDataService} from '../../../services/shared-data.service';
import {DasboardConfiguration} from '../../../models/dashboard';
import {MsReportService} from '../../../services/ms-report.service';
import {AuthorizationService} from '../../../services/authorization.service';
import {Agent} from '../../../models/users';
import {BoldBI} from '@boldbi/boldbi-embedded-sdk';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-agent-metrics',
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './agent-metrics.component.html',
  styleUrl: './agent-metrics.component.scss'
})
export class AgentMetricsComponent implements OnInit {

  embedConf: DasboardConfiguration | null = null;
  serverURL: string = '';
  embededType: string = '';
  dashboardId: string = '';
  environment: string = '';
  dashboard: any;
  isLoading: boolean = true;
  agent: Agent | null = null;

  constructor(
    public layoutService: LayoutService,
    public renderer: Renderer2,
    public router: Router,
    private sharedDataService: SharedDataService,
    private msReportService: MsReportService,
    private authService: AuthorizationService,
  ) {

  }

  ngOnInit(): void {
    this.agent = this.sharedDataService.getAgent();

    this.loadDashboardConfig();
  }

  loadDashboardConfig() {
    this.isLoading = true;
    this.msReportService.GetEmbedConfig().subscribe((data) => {
      this.embedConf = data;

      this.serverURL = `${this.embedConf.serverUrl}/${this.embedConf.siteIdentifier}`;
      this.embededType = this.embedConf.embedType;
      this.dashboardId = this.embedConf.dashboardId;
      this.environment = this.embedConf.environment;

      this.msReportService.GetDashboards().subscribe((data) => {
        this.renderDashboard();
      });
    });
  }

  renderDashboard() {
    this.isLoading = true;
    const base_url = this.msReportService.baseUrl;

    // Recupera el token desde localStorage
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      this.isLoading = false;
      return;
    }

    // Crea e inyecta el dashboard
    this.dashboard = BoldBI.create({
      serverUrl: this.serverURL,
      dashboardId: this.dashboardId,
      embedContainerId: 'dashboard',
      embedType: this.embededType,
      environment: this.environment,
      width: '100%',
      height: '100%',
      expirationTime: 100000,
      authorizationServer: {
        url: `${base_url}authorizationserver`,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: '*/*'
        }
      },
      filterParameters: `AgentId=${this.agent?.id}`,
      dashboardSettings: {
        showExport: true,
        showRefresh: true,
        showMoreOption: true,
        themeSettings: {
          appearance: 'dark'
        }
      }
    });

    // Carga el dashboard
    this.dashboard.loadDashboard();
  }
}
